/** Outlevo for Gmail on the Chrome Web Store (unlisted: reachable by this link, not by store search) */
export const GMAIL_EXTENSION_URL = 'https://chromewebstore.google.com/detail/outlevo-for-gmail/lccpkmbhdlbaoeloeinjhpjcfaafloen';
